import type { UserRoutes } from "@remhealth/core";

const root = "/quality";

export type QualityTab = "dashboard" | "review" | "audits" | "reviewer-dashboard";

export const qualityRoutes = {
  root,
  tab: `${root}/:tab`,
} as const;

export type QualityAssuranceSettingsSection = "quality-questionnaire" | "users";

const qualityAssuranceSettingsRoot = `${root}/settings`;

export const qualityAssuranceSettingsRoutes = {
  root: qualityAssuranceSettingsRoot,
  section: `${qualityAssuranceSettingsRoot}/:section`,
  users: `${qualityAssuranceSettingsRoot}/users`,
  importUsers: `${qualityAssuranceSettingsRoot}/users/import`,
  user: `${qualityAssuranceSettingsRoot}/users/:user_id`,
  myProfile: `${qualityAssuranceSettingsRoot}/profile`,
  profile: `${qualityAssuranceSettingsRoot}/profile/:user_id`,
} as const;

/** User management and profile navigation routes when hosted inside the Quality Assurance settings tab. */
export const qualityAssuranceUserRoutes: UserRoutes = {
  manageUsers: qualityAssuranceSettingsRoutes.users,
  myProfile: qualityAssuranceSettingsRoutes.myProfile,
  profile: qualityAssuranceSettingsRoutes.profile,
  user: qualityAssuranceSettingsRoutes.user,
};
